import { useState } from 'react';

import moment from 'moment';

/**
 * Custom hook to manage segment component logic
 * Shared between SegmentComponent (desktop) and SegmentComponentMobile
 */
export const useSegmentLogic = (handleSegmentTimeChange, onSegmentSelect) => {
  const [error, setError] = useState('');

  const validateDate = (key, value, record) => {
    if (key === 'endTime') {
      let end = moment(value, 'h:mm a').format('h:mm a');
      let start = record?.startTime;

      /**
       * -1 -> start time less than end time (invalid)
       *  0 -> start and end time are same (invalid)
       *  1 -> start time greater than end time (valid)
       */
      let valid = Math.sign(
        moment(end, 'h:mm a').diff(moment(start, 'h:mm a'))
      );
      
      if (valid === 0) {
        setError('Start and End time are same!');
      } else if (valid === -1) {
        setError('');
      } else {
        setError('');
      }
    }

    handleSegmentTimeChange(key, value, record);
  };

  const handleSegmentSelect = (value, record) => {
    onSegmentSelect && onSegmentSelect(value, record);
  };

  const clearError = () => setError('');

  return {
    error,
    validateDate,
    handleSegmentSelect,
    clearError,
  };
};